var exports = {
  "HC": "sidebarToggleButton__8v_seX",
  "tb": "sidebarHeading__Ast46W",
  "r3": "dialog__PyiVOb",
};

module.exports = exports;
